/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useDispatch } from "react-redux";
import { clearConsRedux, clearLablRedux, getActConsRedux, getActLablRedux } from "../../redux/slices/activity.feature";
import { getConsumptionColumns, getLabellingColumns } from "./ActivityColumns";
import { DtGrid2 } from "../common/DtGrid2";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { Link } from "react-router-dom";
import { DtGridPropsOptions2 } from "../../types/dtGridPropsOptions2";
import { useTranslation } from "react-i18next";
import { getExceptionText, translateColumns } from "../../translations/gridTranslationHelper";
import { parseBool } from "../../aplUtils/extensions";
import { AplParameter } from "../../types/aplParameter";
import { getTextColor } from "../../aplUtils/themeHelper";
import { getAplTokens } from "../../aplUtils/cookiesWrapper";

export default function ActivityDefault() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const aplSettings = AplSettingsSelector();
    const showJobInStr = aplSettings.siteParams.find(p => p.aplParameterType === AplParameter.InlineConsumption);
    const showJobIn = parseBool(showJobInStr?.value);

    const loadData = () => {
        dispatch(getActConsRedux({ siteId: aplSettings.siteId, departmentId: aplSettings.departmentId }));
        dispatch(getActLablRedux({ siteId: aplSettings.siteId, departmentId: aplSettings.departmentId }));
    };

    React.useEffect(() => {
        loadData();
        const interval = setInterval(() => {
            if (getAplTokens().token) loadData();
        }, 30 * 1000);
        return () => {
            clearInterval(interval);
            dispatch(clearConsRedux());
            dispatch(clearLablRedux());
        };
    }, [aplSettings.departmentId]);

    const dtGridPropsCons: DtGridPropsOptions2 = {
        data: aplSettings.activity.actCons,
        columnData: translateColumns(getConsumptionColumns(aplSettings.site, aplSettings.culture, showJobIn), aplSettings.culture),
        loading: aplSettings.activity.actConsLoading,
        tableName: "actCons",
        paging: false,
        showSpinner: aplSettings.activity.actConsLoading && (aplSettings.activity.actCons ?? []).length === 0,
        defaultSort: {
            field: ["lineId"],
            direction: ["asc"]
        },
        selectType: "none",
        colouring: false,
        headerFilters: false,
        setSelectedItems: () => {},
        tableClass: "table-activity",
        rowId: "lineId",
        pageLength: 100,
        selectedItems: [],
        filters: {},
        setFilters: () => {},
        page: 1,
        setPage: () => {}
    };

    const dtGridPropsLabl: DtGridPropsOptions2 = {
        data: aplSettings.activity.actLabl,
        columnData: translateColumns(getLabellingColumns(aplSettings.site, aplSettings.culture), aplSettings.culture),
        loading: aplSettings.activity.actLablLoading,
        tableName: "actLabl",
        paging: false,
        showSpinner: aplSettings.activity.actLablLoading && (aplSettings.activity.actLabl ?? []).length === 0,
        defaultSort: {
            field: ["lineId"],
            direction: ["asc"]
        },
        selectType: "none",
        colouring: false,
        headerFilters: false,
        setSelectedItems: () => {},
        tableClass: "table-activity",
        rowId: "lineId",
        pageLength: 100,
        selectedItems: [],
        filters: {},
        setFilters: () => {},
        page: 1,
        setPage: () => {}
    };

    return (
        <React.Fragment>
            <div id="div-error" className={`alert alert-danger ${aplSettings.activity.actConsError ? "" : "hide"}`} role="alert">
                {getExceptionText(aplSettings.activity.actConsError, aplSettings.culture)}
            </div>

            <div id="div-error" className={`alert alert-danger ${aplSettings.activity.actLablError ? "" : "hide"}`} role="alert">
                {getExceptionText(aplSettings.activity.actLablError, aplSettings.culture)}
            </div>

            <div className="container activity mw-100">
                <div className="row">
                    <div className="col-6">
                        <h2
                            className="rounded-lg pl-2"
                            style={{
                                backgroundColor: aplSettings.theme.consumptionColour ? aplSettings.theme.consumptionColour : "inherit",
                                color: aplSettings.theme.consumptionColour ? getTextColor(aplSettings.theme.consumptionColour) : "inherit"
                            }}
                        >
                            <Link
                                style={{
                                    color: aplSettings.theme.consumptionColour
                                        ? getTextColor(aplSettings.theme.consumptionColour)
                                        : "inherit"
                                }}
                                to="/consumption"
                            >
                                {t("main.rxg_Consumption")}
                            </Link>
                        </h2>
                        <DtGrid2 options={dtGridPropsCons} />
                    </div>
                    <div className="col-6">
                        <h2
                            className="rounded-lg pl-2"
                            style={{
                                backgroundColor: aplSettings.theme.labellingColour ? aplSettings.theme.labellingColour : "inherit"
                            }}
                        >
                            <Link
                                style={{
                                    color: aplSettings.theme.labellingColour ? getTextColor(aplSettings.theme.labellingColour) : "inherit"
                                }}
                                to="/labels"
                            >
                                {t("main.defaultActivityLabeling")}
                            </Link>
                        </h2>
                        <DtGrid2 options={dtGridPropsLabl} />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
